// App.js
import { useEffect, useState } from "react";
import AdminPanel, { ADMIN_CHAT_STORAGE_KEY } from "./components/admin/AdminPanel";
import Dashboard from "./components/layout/Dashboard";
import LoginPage from "./components/auth/LoginPage";
import { clearChatSession, fetchCurrentUser, logoutUser } from "./api";
import { clearStoredChatSession } from "./components/chat/ChatFab";

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [view, setView] = useState("public");
  const [loginCanBack, setLoginCanBack] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetchCurrentUser()
      .then((user) => {
        if (cancelled) return;
        setCurrentUser(user);
        setView("admin");
      })
      .catch(() => {
        if (!cancelled) setCurrentUser(null);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const openLogin = () => {
    setLoginCanBack(true);
    setView("login");
  };

  const handleLogin = (user) => {
    setCurrentUser(user);
    setLoginCanBack(false);
    setView("admin");
  };

  const handleLogout = async () => {
    try {
      await clearChatSession();
    } catch {
      // Logout should still continue if the chat session is already gone.
    }

    clearStoredChatSession(ADMIN_CHAT_STORAGE_KEY);

    try {
      await logoutUser();
    } finally {
      setCurrentUser(null);
      setLoginCanBack(true);
      setView("login");
    }
  };

  if (view === "admin" && currentUser) {
    return <AdminPanel currentUser={currentUser} onLogout={handleLogout} />;
  }

  if (view === "login") {
    return (
      <LoginPage
        onLogin={handleLogin}
        onBack={loginCanBack ? () => setView("public") : undefined}
      />
    );
  }

  return <Dashboard onLoginClick={openLogin} />;
}

export default App;
